export default function NotFound() {
  return (
    <div>
      <h1>Sorry, page not found</h1>
    </div>
  );
}
